import {Code, ConnectError} from '@connectrpc/connect';

import {ErrorInfoSchema} from '../../generated/google/rpc/error_details_pb';

// The reason the bay-session FullSwingAuth handler attaches when a session_id
// resolves to a station it doesn't manage — the only signal the mobile login
// falls back to the legacy path on. Must stay in lockstep with the server
// constant of the same value; a server-side test pins the literal so drift
// fails CI.
export const STATION_NOT_BAY_SESSION_MANAGED = 'STATION_NOT_BAY_SESSION_MANAGED';

/**
 * Reports whether `err` is the "station not bay-session-managed" signal — and
 * nothing else. The server emits it as Code.NotFound carrying an ErrorInfo
 * detail whose `reason` matches; the user-miss path also returns a bare
 * Code.NotFound, so the detail's reason — not the code — is the discriminator.
 * Every other error returns false so the caller surfaces it with no fallback.
 * Works on both native gRPC-web (detail in the status trailer) and Connect.
 */
export function isStationNotBaySessionManaged(err: unknown): boolean {
  const connectErr = ConnectError.from(err);
  if (connectErr.code !== Code.NotFound) {
    return false;
  }
  for (const info of connectErr.findDetails(ErrorInfoSchema)) {
    if (info.reason === STATION_NOT_BAY_SESSION_MANAGED) {
      return true;
    }
  }
  return false;
}
